import { createAPI } from '@common'
export default {
  // 根据docLibID获取其根文件夹ID
  getRootIdByDocLibID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 获取区划树
  getRegionTreeData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0usff', 'GET', config, {
      timeout: 120000
    }),
  // 新建区划
  postAddRegion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst', 'POST', config),
  // 修改区划
  postUpdateRegion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefst', 'POST', config),
  // 删除区划
  deleteRegion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst', 'DELETE', config),
  // 新建/修改角色
  postE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0spmft', 'post', config),
  // 删除角色
  deleteE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0spmft', 'delete', config),
  // 获取角色列表
  getE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0spmft', 'get', config),
  // 租户拖拽
  postFolderMove: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0ufobou0npwf', 'post', config),
  // 移动拖拽
  postFolderMoves: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0npwf', 'post', config),
  // 右侧用户列表筛选条件 - 获取角色下拉
  getRoleOptions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0spmft0hfuSpmftCzPshJE', 'get', config),
    // 租户属性获取
  getTenantInfo: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0ufobou0jogp', 'get', config),
  // 租户属性设置
  postTenantInfo: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0ufobou0jogp', 'post', config)
}
